var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outbox"},[_c('out-box-message-list',{attrs:{"messages":_vm.messages}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }